import preloader from "./preloader";
import {displayFormError} from "./helper";

var register = function () {
    $('.register-form').on('submit', function(e){
        e.preventDefault();

        let form = $(this);

        preloader(form, true);

        form.find('.danger-alert').addClass('d-none');

        let data = form.serializeArray();

        let formData = new FormData();

        for(let key in data){
            formData.append(data[key]['name'], data[key]['value']);
        }

        if(form.find('input[type="file"]').val()){
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function( response ){
                preloader(form, false);

                if(response.errors){
                    alert('Internal Error! Contact Administrator!');
                }else{

                    $('html, body').animate({
                        scrollTop: form.offset().top-300
                    }, 300);

                    form.html('<h4 class="text-center">'+ response.message +'</h4>')
                }
            },
            error: function( responseError){
                displayFormError(form, responseError)
            }
        });
    })
}

export default register;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/register.js